import { render, staticRenderFns } from "./MoleculeEditionSectionContentFooter.vue?vue&type=template&id=45ef077e&"
import script from "./MoleculeEditionSectionContentFooter.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionSectionContentFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports